import React, { useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function Faqs({ faqs = [], loading = false }) {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Default FAQs if none provided
  const displayFaqs = faqs.length > 0 ? faqs : [
    { question: "How can I track my order?", answer: "You can track your order using the link sent to your email or by visiting the 'My Orders' section in your account." },
    { question: "What is your return policy?", answer: "We offer a 30-day return policy for most items. Products must be in original packaging and unused condition." },
    { question: "Do you offer international shipping?", answer: "Yes, we ship to over 50 countries. Shipping costs and delivery times vary by location." }
  ];

  return (
    <section className="faq-section py-5 px-3">
      <div className="container custom-container">
        {/* 🔹 Header Section */}
        <div className="text-center mb-5">
          <h2 className="faq-title">Frequently Asked Questions</h2>
          <p className="text-muted">Everything you need to know about our products and services.</p>
        </div>

        {/* 🔹 Accordion Section */}
        <div className="faq-container">
          {loading
            ? Array.from({ length: 4 }).map((_, idx) => (
                <div key={idx} className="mb-3">
                  <Skeleton height={60} borderRadius={12} />
                </div>
              ))
            : displayFaqs.map((faq, idx) => (
                <div 
                  key={idx} 
                  className={`faq-item ${activeIndex === idx ? "active" : ""}`}
                >
                  <button 
                    className="faq-question" 
                    onClick={() => toggleAccordion(idx)}
                    aria-expanded={activeIndex === idx}
                  >
                    <span>{faq.question}</span>
                    <span className="faq-icon"></span>
                  </button>
                  <div className="faq-answer">
                    <div className="answer-content">
                      {faq.answer}
                    </div>
                  </div>
                </div>
              ))}
        </div>
      </div>

      <style>{`
        .faq-section {
          background-color: #fcfcfc;
        }

        .custom-container {
          max-width: 800px;
          margin: 0 auto;
        }

        .faq-title {
          font-weight: 800;
          color: #1a1a1a;
          font-size: 2rem;
          margin-bottom: 10px;
        }

        .faq-container {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .faq-item {
          background: #ffffff;
          border: 1px solid #eaeaea;
          border-radius: 16px;
          overflow: hidden;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .faq-item.active {
          border-color: #ff4757;
          box-shadow: 0 10px 25px rgba(255, 71, 87, 0.1);
        }

        .faq-question {
          width: 100%;
          padding: 20px 25px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: none;
          border: none;
          outline: none;
          text-align: left;
          font-size: 1.1rem;
          font-weight: 600;
          color: #2d3436;
          cursor: pointer;
        }

        .faq-icon {
          position: relative;
          width: 20px;
          height: 20px;
          flex-shrink: 0;
          transition: transform 0.3s ease;
        }

        .faq-icon::before, .faq-icon::after {
          content: "";
          position: absolute;
          background-color: #ff4757;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        /* Horizontal line */
        .faq-icon::before {
          width: 14px;
          height: 2px;
        }

        /* Vertical line */
        .faq-icon::after {
          width: 2px;
          height: 14px;
          transition: opacity 0.3s ease;
        }

        .faq-item.active .faq-icon {
          transform: rotate(180deg);
        }

        .faq-item.active .faq-icon::after {
          opacity: 0;
        }

        .faq-answer {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.4s ease-in-out, opacity 0.3s ease;
          opacity: 0;
        }

        .faq-item.active .faq-answer {
          max-height: 500px; /* Large enough to fit content */
          opacity: 1;
        }

        .answer-content {
          padding: 0 25px 25px 25px;
          color: #636e72;
          line-height: 1.6;
          font-size: 1rem;
        }

        /* Mobile Adjustments */
        @media (max-width: 768px) {
          .faq-title {
            font-size: 1.5rem;
          }
          .faq-question {
            padding: 15px 20px;
            font-size: 1rem;
          }
          .answer-content {
            padding: 0 20px 20px 20px;
            font-size: 0.95rem;
          }
        }
      `}</style>
    </section>
  );
}

export default Faqs;